/**
 * i18next — UA / RU / EN.
 * Язык интерфейса НЕ равен языку генерации (они независимы, см. CLAUDE.md).
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ua from './locales/ua/common.json';
import ru from './locales/ru/common.json';
import en from './locales/en/common.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ua: { translation: ua },
      ru: { translation: ru },
      en: { translation: en },
    },
    fallbackLng: 'en',
    // 2026-07-28 hotfix: dev-debug=true спамит missingKey в консоли на каждом
    // ререндере Sidebar/Breadcrumbs, когда текущий язык грузится не сразу.
    // Оставляем console.error/warn (только реальные ошибки), без per-key логов.
    debug: false,
    interpolation: { escapeValue: false },
  });

export default i18n;
